import { connect } from "react-redux";
import { saveStep6, changeStep } from "../../../services/Actions/Auth";
function Step6(props) {
  function handleClick(e) {
    props.saveStep6(e.target.value);
    props.changeStep(7);
  }
  return (
    <div className="Step">
      <div className="container">
        <div className="question-box" data-aos="fade-down" data-aos-delay="100">
          <h2>What is your current job status?</h2>
        </div>
        <div className="option-box">
          <button
            className="button outline"
            value="I am a student/intern"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="300"
          >
            I am a student/intern
          </button>
          <button
            className="button outline"
            value="Pupil / Child"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="500"
          >
            Pupil / Child
          </button>
          <button
            className="button outline"
            value="Housewife / Househusband"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="700"
          >
            Housewife / Househusband
          </button>
          <button
            className="button outline"
            value="Without employment"
            onClick={handleClick}
            data-aos="fade-up"
            data-aos-delay="900"
          >
            Without employment
          </button>
        </div>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  saveStep6,
  changeStep,
};

export default connect(null, mapDispatchToProps)(Step6);
